import { type JSX } from 'solid-js'
import Css from './filters.module.scss'

/**
 * Os campos de filtro do painel.
 *
 * ## O contador de revisao NAO e usado aqui
 *
 * O scope traz `formRevision`, que conta escritas programaticas nos campos. Ele
 * existe por causa do React: la os campos sao NAO controlados - um campo controlado
 * tem o valor restaurado ao fim de cada evento, e como o scope atualiza em lote isso
 * come tecla digitada -, e campo nao controlado ignora mudanca de `defaultValue`,
 * entao o "Limpar" esvaziava o scope sem esvaziar a tela. O `key` na revisao
 * remontava o campo.
 *
 * Em Solid nao ha esse problema: `value={scope.name}` e uma ligacao fina, escreve o
 * DOM so quando o valor muda de verdade e nao interfere na digitacao. O campo e
 * controlado, o "Limpar" limpa, e `formRevision` fica sem uso - e e correto que
 * fique, porque ele e compensacao de um renderizador e nao informacao de produto.
 */

export function TextFilter(props: {
    label: string
    placeholder?: string
    value: string
    onChange: (value: string) => void

    /**
     * O campo mostra, mas nao aceita edicao.
     *
     * `readonly` e nao `disabled` para o que e IMUTAVEL e ainda assim se quer copiar -
     * CNPJ, CPF, e-mail de login. Desabilitado tiraria o campo da ordem de tabulacao e
     * impediria selecionar o texto.
     *
     * Existe porque a ausencia dele foi um defeito de verdade: a apresentacao marcava
     * CNPJ, razao social e e-mail como `readOnly`, a view nao repassava, e os tres
     * apareciam editaveis. O servidor recusa a troca de CNPJ por quem nao e
     * administrador geral, entao a tela prometia o que o servidor nega - e o salvar
     * ainda dizia "editado com sucesso", porque o campo sequer era enviado.
     */
    readOnly?: boolean

    /** Fora de uso e fora da tabulacao - mais forte que `readOnly`. */
    disabled?: boolean

    /**
     * Sobre a faixa ESCURA de filtros.
     *
     * Mesma forma de vidro do `onDark` do menu e do campo de data: branco a 15% sobre o
     * que estiver atras, sem borda declarada. Nasceu quando os cartoes de filtro brancos
     * dos Monitoramentos e das Empresas viraram faixa escura, como os das outras telas.
     */
    onDark?: boolean
}): JSX.Element {
    const locked = () => props.readOnly || props.disabled

    return (
        <label class={Css.field} classList={{ [Css.onDark]: props.onDark }}>
            <span class={Css.label}>{props.label}</span>
            <input
                value={props.value}
                placeholder={props.placeholder}
                readOnly={props.readOnly}
                disabled={props.disabled}
                onInput={(event) => props.onChange(event.currentTarget.value)}
                class={Css.input}
                classList={{ [Css.locked]: locked() }}
            />
        </label>
    )
}
